//styles

import "./styles.css";
//assets
import WebmuxLogo from "./assets/webmuxNocloud2.png";
// import GpsLogo from "./assets/logonegalpharesize.png";
import GpsLogo from "./assets/gps_logo_neg2026.png";
//mui
import Select from "@mui/material/Select";
import { MenuItem, Stack, Modal, Button, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
//circle-flags
import { CircleFlag } from "react-circle-flags";
//logic
import { Login } from "./scripts/login";
//i18
import i18next, { t } from "i18next";
import "./translations/i18n";
import { withTranslation } from "react-i18next";
import { useEffect, useState } from "react";
// import { ElementCollection } from "./elemscol";
// import { LoginManager } from "./login";

export const modal_container = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#fff",
  outline: "none",
  padding: "20px",
  width: "400px", // Imposta la larghezza massima del modal
  maxHeight: "100vh", // Imposta l'altezza massima del modal
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px",
};

function App() {
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [isModalErrorOpen, setIsModalErrorOpen] = useState(false);
  const [language, setLanguage] = useState("it");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    // Leggi il parametro 'lang' dall'URL
    const urlParams = new URLSearchParams(window.location.search);
    const langFromUrl = urlParams.get("lang") || urlParams.get("language");

    // Determina quale lingua usare (URL > browser language)
    let languageToSet = langFromUrl;

    if (!languageToSet) {
      let languageBrowser = navigator.language.split("-")[0];

      if (languageBrowser === "it") {
        languageToSet = "it";
      } else if (languageBrowser === "en") {
        languageToSet = "en";
      } else if (languageBrowser === "fr") {
        languageToSet = "fr";
      } else if (languageBrowser === "de") {
        languageToSet = "de";
      } else if (languageBrowser === "nl") {
        languageToSet = "nl";
      } else if (languageBrowser === "es") {
        languageToSet = "esp";
      } else if (languageBrowser === "sv") {
        languageToSet = "sve";
      } else if (languageBrowser === "ja") {
        languageToSet = "jp";
      } else {
        languageToSet = "it"; // default
      }

      console.log(`LINGUA: ${languageBrowser}`);
    }

    handleLanguageChange(languageToSet);
    setLanguage(languageToSet);
  }, []);

  function handleUsernameChange(e) {
    setUsername(e.target.value);
  }
  function handlePasswordChange(e) {
    setPassword(e.target.value);
  }

  function handleLogin(usr, psw, redirect) {
    /* I campi non sono controllati da React - non hanno value - quindi il
       valore vero sta nel DOM. Il riempimento automatico del browser, e i
       valori che restano dopo l'uscita, scrivono nel DOM SENZA far scattare
       onChange: lo stato username/password resta vuoto e si spedivano
       credenziali vuote, con i campi visibilmente pieni e il messaggio
       "password e/o username errati".
       Si legge quindi dal DOM, che per un campo non controllato e' la fonte
       vera; i parametri restano come riserva. */
    const usrEl = document.getElementById("usr");
    const pswEl = document.getElementById("psw");
    const user = usrEl && usrEl.value !== "" ? usrEl.value : usr;
    const pass = pswEl && pswEl.value !== "" ? pswEl.value : psw;

    const res = Login(user, pass, redirect);

    res.then((data) => {
      if (data instanceof TypeError || data instanceof Error) {
        setIsModalErrorOpen(true);
      } else {
        console.log(data.RedirectTo);
        var urlDestination =
          data.RedirectTo + "?language=" + encodeURIComponent(language);

        window.location.href = urlDestination;
      }
    });
  }

  function handleLanguageChange(lang) {
    setLanguage(lang);
    i18next.changeLanguage(lang);
  }

  function handleKeyDown(e) {
    //debugger;
    if (e.key === "Enter") {
      handleLogin(username, password, false);
    }
  }

  function handleClickShowPassword() {
    setShowPassword(!showPassword);
  }

  return (
    <>
      <div
        className="App"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleLogin(username, password, false);
          }
        }}>
        <div className="bg">
          <div
            style={{
              minHeight: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}>
            <img src={WebmuxLogo} alt="webmux logo" className="logo" />
            <Select
              defaultValue={"it"}
              sx={{ marginBottom: "15px", marginTop: "10px", color: "white" }}
              value={language}
              onChange={(e) => {
                handleLanguageChange(e.target.value);
              }}>
              <MenuItem value={"it"} on>
                <Stack
                  direction={"row"}
                  sx={{ alignItems: "center" }}
                  spacing={2}>
                  <CircleFlag countryCode="it" height={30} />
                  <h4>Italiano</h4>
                </Stack>
              </MenuItem>
              <MenuItem value={"en"}>
                <Stack
                  direction={"row"}
                  sx={{ alignItems: "center" }}
                  spacing={2}>
                  <CircleFlag countryCode="uk" height={30} />
                  <h4>English</h4>
                </Stack>
              </MenuItem>
              <MenuItem value={"fr"}>
                <Stack
                  direction={"row"}
                  sx={{ alignItems: "center" }}
                  spacing={2}>
                  <CircleFlag countryCode="fr" height={30} />
                  <h4>Français</h4>
                </Stack>
              </MenuItem>
              <MenuItem value={"de"}>
                <Stack
                  direction={"row"}
                  sx={{ alignItems: "center" }}
                  spacing={2}>
                  <CircleFlag countryCode="de" height={30} />
                  <h4>Deutsch</h4>
                </Stack>
              </MenuItem>
              <MenuItem value={"nl"}>
                <Stack
                  direction={"row"}
                  sx={{ alignItems: "center" }}
                  spacing={2}>
                  <CircleFlag countryCode="nl" height={30} />
                  <h4>Nederlands</h4>
                </Stack>
              </MenuItem>
              <MenuItem value={"esp"}>
                <Stack
                  direction={"row"}
                  sx={{ alignItems: "center" }}
                  spacing={2}>
                  <CircleFlag countryCode="es" height={30} />
                  <h4>Español</h4>
                </Stack>
              </MenuItem>
              <MenuItem value={"sve"}>
                <Stack
                  direction={"row"}
                  sx={{ alignItems: "center" }}
                  spacing={2}>
                  <CircleFlag countryCode="se" height={30} />
                  <h4>Svenska</h4>
                </Stack>
              </MenuItem>
              <MenuItem value={"jp"}>
                <Stack
                  direction={"row"}
                  sx={{ alignItems: "center" }}
                  spacing={2}>
                  <CircleFlag countryCode="jp" height={30} />
                  <h4>日本語</h4>
                </Stack>
              </MenuItem>
            </Select>

            <main class="form-container">
              <form>
                <div class="form-group">
                  <label class="form-label" for="username">
                    {t("username")}
                  </label>
                  <input id="usr" type="text" onChange={handleUsernameChange} />
                </div>
                <div class="form-group">
                  <label class="form-label" for="password">
                    {t("password")}
                  </label>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      id="psw"
                      type={showPassword ? "text" : "password"}
                      onChange={handlePasswordChange}
                      onKeyDown={handleKeyDown}
                      style={{ border: "none", outline: "none" }}
                    />
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      style={{
                        marginLeft: "10px",
                        color: "yellow",
                        marginBottom: "30px",
                        cursor: "pointer",
                      }}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </div>
                </div>
                <button
                  id="login_submit"
                  type="button"
                  onClick={() => {
                    handleLogin(username, password, false);
                  }}>
                  {t("login")}
                </button>
                <p class="text-register">
                  {t("registerMsg")}{" "}
                  <a
                    // href={`https://webmux.cloud/register/?lang=${encodeURIComponent(language)}`}>
                    href={`./register/?lang=${encodeURIComponent(language)}`}>
                    {t("registerMsg2")}
                  </a>
                </p>
              </form>
            </main>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginTop: "10px",
              }}>
              <a
                href={`https://www.gps-standard.com/${language === "it" ? "it" : "en"}/privacy.html`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "white",
                  textDecoration: "underline",
                  marginBottom: "20px",
                  fontSize: "14px",
                  fontWeight: "normal",
                }}>
                PRIVACY POLICY
              </a>
              <span
                style={{
                  color: "white",
                  fontSize: "12px",
                  marginBottom: "20px",
                }}>
                |
              </span>
              <a
                href="./Privacy Cookies GPS.pdf"
                // href={`${process.env.PUBLIC_URL}/Privacy Cookies GPS.pdf`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "white",
                  textDecoration: "underline",
                  marginBottom: "20px",
                  fontSize: "14px",
                  fontWeight: "normal",
                }}>
                COOKIE POLICY
              </a>
            </div>
            <img className="gps-logo" src={GpsLogo} alt="Gps Standard Logo" />
          </div>
        </div>
        {/* <dialog id="login_dialog">
          <article>
            <header>
              <a href="#close" aria-label="Close" class="close"></a>
              Login Failed
            </header>
            <p id="login_dialogmessage"> </p>
          </article>
        </dialog> */}
      </div>
      <Modal open={isModalErrorOpen}>
        <div style={modal_container}>
          <h3>{t("modalMsg")}</h3>
          <Button
            variant="contained"
            onClick={() => {
              setIsModalErrorOpen(false);
            }}>
            Ok
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default withTranslation()(App);
